import React,{useRef} from 'react';
import { Component } from 'react';
import ReactDOM from 'react-dom';

import Header from "../components/header";
import List from "../components/index/list";

export default class Index extends Component {
    constructor(props){
        super(props)

        this.state = {
            name: '',
            films: [],
            error: null,
        }

        this.seeing = this.seeing.bind(this)
        this.see = this.see.bind(this)
        this.pending = this.pending.bind(this)
    }

    seeing(id){
        try{
            fetch(https+'api/seeing/'+id)
                .then(response => response.json())
                .then(data =>{
                    this.setState({
                        films:data,
                    })
                })
        }catch (error) {
            this.setState({
                error
            })
        }
    }
    
    see(id){
        try{
            fetch(https+'api/see/'+id)
                .then(response => response.json())
                .then(data =>{
                    this.setState({
                        films:data,
                    })
                })
        }catch (error) {
            this.setState({
                error
            })
        }
    }
    
    pending(id){
        try{
            fetch(https+'api/pending/'+id)
                .then(response => response.json())
                .then(data =>{
                    this.setState({
                        films:data,
                    })
                })
        }catch (error) {
            this.setState({
                error
            })
        }
    }


    async componentDidMount(){
        //banner
        try{
            let res = await fetch(https+'api/films')
            let data = await res.json()
            this.setState({
                films:data
            })
        }catch (error) {
            this.setState({
                error
            })
        }

    }
    

    render() {
        return (
            <div>
                <Header
                />
                <List
                    list={this.state.films}
                    seeing={this.seeing}
                    see={this.see}
                    pending={this.pending}
                />
            </div>
        );
    }

}

if (document.getElementById('content_home')) {
    ReactDOM.render(<Index />, document.getElementById('content_home'))
}
